/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IContainsDictionariesRemoteDto } from "./i-contains-dictionaries-remote-dto";
import { IRemoteDto } from "./i-remote-dto";

export class CallTagsForSingleCallRemoteDto implements IContainsDictionariesRemoteDto, IRemoteDto {
    dictionaryProperties: string[];
    callId: number;
    callUId: string;
    callTags: { [key: string]: string; };
}
